<template lang="html">
  <v-snackbar
    :timeout="0"
    multi-line
    :color="snackbarType"
    default
    bottom
    v-model="snackbar">
      {{snackbarText}}
    <v-btn text left class="white--text" @click.native="HIDE_SNACKBAR()">fechar</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('ui', [
      'snackbarType',
      'snackbarText',
      'snackbar'
    ])
  },

  methods: {
    ...mapActions('ui', [
      'HIDE_SNACKBAR'
    ])
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// snackbar.vue?5503b721